var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import Layout from '@/container/Layout';
import { HotlineMeta } from '@/feature/hotline/component/HotlineMeta';
import { HOTLINE_INTERVIEW_STATUS_UNSET, HOTLINE_INTERVIEW_STATUS_BLOCK, } from '@/feature/hotline/constant/interviewStatus';
import { useHotlineProDetailFetch } from '@/feature/hotline/professional/detail/hook/useHotlineProDetailFetch';
import { HotlineProDetailMeetingView } from '@/feature/hotline/professional/detail/meeting/page/HotlineProDetailMeetingView';
import { HotlineProDetailMeetingViewSkeleton } from '@/feature/hotline/professional/detail/meeting/page/HotlineProDetailMeetingViewSkeleton';
import { useHotlineProDetailNegotiateCancel } from '@/feature/hotline/professional/detail/negotiate/hook/useHotlineProDetailNegotiateCancel';
import { useHotlineProDetailNegotiatePhone } from '@/feature/hotline/professional/detail/negotiate/hook/useHotlineProDetailNegotiatePhone';
import { useHotlineProDetailReschedulePro } from '@/feature/hotline/professional/detail/negotiate/hook/useHotlineProDetailReschedulePro';
import { isDetailDataHasRequestInterview, isFirstRepliedDetailData, } from '@/feature/hotline/professional/detail/util/typeGuard';
import { useParams } from '@/hooks/lib/react-router/useParams';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { pagePath } from '@/utils/router/pagePath';
const hotlineProPath = pagePath.hotline.professional;
/**
 * 匿名ホットライン 面談実施ページ（ロジック部分のみ）
 * @description api データ取得, その他ロジック部分
 */
export const HotlineProDetailMeetingPage = () => {
    var _a, _b, _c;
    const { id = '' } = useParams();
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const { detailData, fetchDetailData, isLoading } = useHotlineProDetailFetch({
        dispatch,
        id,
        unmountRef,
    });
    const detailOneData = detailData[id];
    const requestId = ((_a = detailOneData === null || detailOneData === void 0 ? void 0 : detailOneData.hotline_request) === null || _a === void 0 ? void 0 : _a.id) || null;
    const interviewId = ((_c = (_b = detailOneData === null || detailOneData === void 0 ? void 0 : detailOneData.hotline_request) === null || _b === void 0 ? void 0 : _b.hotline_request_interview) === null || _c === void 0 ? void 0 : _c.id) || null;
    /**
     * 連絡先更新 送信処理
     */
    const { onSubmitPhone } = useHotlineProDetailNegotiatePhone({
        dispatch,
        id,
        interviewId,
        onSuccess: fetchDetailData,
        requestId,
    });
    /**
     * キャンセルモーダル送信処理
     */
    const { onSubmitCancel } = useHotlineProDetailNegotiateCancel({
        dispatch,
        id,
        onSubmitCallback: fetchDetailData,
    });
    /**
     * 日程変更 送信処理
     */
    const { onSubmitScheduleChange } = useHotlineProDetailReschedulePro({
        dispatch,
        id,
        onSubmitCallback: fetchDetailData,
    });
    // 詳細データ取得
    useEffect(() => {
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            if (!detailOneData) {
                yield fetchDetailData();
            }
        }))();
    }, [detailOneData, fetchDetailData]);
    if (isLoading && !detailOneData) {
        return (_jsx(Layout, Object.assign({ mainClassName: 'l-main' }, { children: _jsx(HotlineProDetailMeetingViewSkeleton, {}) })));
    }
    // データがない場合、一覧へリダイレクト
    if (!detailOneData) {
        return _jsx(CustomRedirect, { to: hotlineProPath.list() });
    }
    // 初回返信前の場合、詳細内容にリダイレクト
    if (!isFirstRepliedDetailData(detailOneData)) {
        return _jsx(CustomRedirect, { to: hotlineProPath.detail(id) });
    }
    // 面談情報がない場合、詳細チャット画面にリダイレクト
    if (!isDetailDataHasRequestInterview(detailOneData)) {
        return _jsx(CustomRedirect, { to: hotlineProPath.detailNegotiate(id) });
    }
    const requestInterview = detailOneData.hotline_request.hotline_request_interview;
    // 初回相談かつ日程未設定 or 初回相談かつキャンセルの場合、詳細チャット画面にリダイレクト
    if ((!requestInterview.is_reordered &&
        requestInterview.status === HOTLINE_INTERVIEW_STATUS_UNSET.value) ||
        (!requestInterview.is_reordered &&
            requestInterview.status === HOTLINE_INTERVIEW_STATUS_BLOCK.value)) {
        return _jsx(CustomRedirect, { to: hotlineProPath.detailNegotiate(id) });
    }
    return (_jsxs(_Fragment, { children: [_jsx(HotlineMeta, { relativePath: pagePath.hotline.professional.detailMeeting(detailOneData.id), title: `${detailOneData.title} | PROFFIT` }), _jsx(Layout, Object.assign({ mainClassName: 'l-main' }, { children: _jsx(HotlineProDetailMeetingView, { detailData: detailOneData, onSubmitCancel: onSubmitCancel, onSubmitScheduleChange: onSubmitScheduleChange, onSubmitUpdateRequest: onSubmitPhone }) }))] }));
};
